<template>
  <div><p style="text-align: center; font-weight: bold;">Regulamin parkowania Wspólnot Mieszkaniowych Osiedle Zielone Wiejska 14, 16, 18.</p></div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      value: "construction..."
    };
  }
};
</script>
